import React from "react";
import "./PageHero.css";

const PageHero = ({ eyebrow, title, lede }) => {
  return (
    <section className="page-hero blueprint">
      <div className="container">
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="h1">{title}</h1>
        {lede && <p className="lede">{lede}</p>}
      </div>
    </section>
  );
};

export default PageHero;
